import apiClient from "./client";

export async function saveObjectives(payload) {
  const res = await apiClient.post("/api/save-objectives", payload);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message);
  return data;
}

export async function updateInitiativeStatus(objectiveId, krId, initId, isCompleted) {
  const res = await apiClient.post("/api/update-initiative-status", {
    objectiveId,
    krId,
    initId,
    is_completed: isCompleted,
  });
  return res;
}

export async function updateNumericProgress(krId, value) {
  const res = await apiClient.post("/api/update-numeric-progress", { kr_id: krId, value });
  return res;
}
